var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 17.1005C21.9982 17.3631 21.8931 17.6145 21.7075 17.8003C21.5219 17.9861 21.2706 18.0914 21.008 18.0935H2.992C2.72881 18.0932 2.4765 17.9885 2.29049 17.8023C2.10448 17.6161 2 17.3637 2 17.1005V16.0935H20V4.39351L12 11.5935L2 2.59351V1.09351C2 0.828289 2.10536 0.573935 2.29289 0.386399C2.48043 0.198863 2.73478 0.0935059 3 0.0935059H21C21.2652 0.0935059 21.5196 0.198863 21.7071 0.386399C21.8946 0.573935 22 0.828289 22 1.09351V17.1005ZM4.434 2.09351L12 8.90351L19.566 2.09351H4.434ZM0 12.0935H8V14.0935H0V12.0935ZM0 7.09351H5V9.09351H0V7.09351Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeWhite);
export default __webpack_public_path__ + "static/media/Envelope-White.edb997a7b3ea5ed34410dda17a7a35aa.svg";
export { ForwardRef as ReactComponent };